import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import InstructionPanel from "../../components/ChainReactionGame/InstructionPanel";

class InstructionContainer extends Component {
  render() {
    return (
      <InstructionPanel
        betLocked={this.props.betLocked}
        isLinkSelected={this.props.focusLinkIndex !== null}
        hasBet={this.props.bet > 0}
      />
    );
  }
}

const mapStateToProps = state => ({
  bet: state.game.bet,
  betLocked: state.game.betLocked,
  focusLinkIndex: state.game.focusLinkIndex
});

const mapDispatchToProps = dispatch => ({
});

InstructionContainer.propTypes = {
  // quizQuestions: PropTypes.array.isRequired,
  // showAnswer: PropTypes.bool.isRequired,
  // index: PropTypes.number.isRequired,
  // onAnswerSelected: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstructionContainer);



// WEBPACK FOOTER //
// ./src/containers/ChainReactionGame/InstructionContainer.js